// permissionUtils.ts

import { RootState } from "@app/store/store";

export const hasPermission = (permissionSystemName: string, userPermissions: Array<{ permissionSystemName: string, scope: string }>) => {
    return userPermissions.some(
      (permission) => permission.permissionSystemName === permissionSystemName && permission.scope === 'ALLOWED'
    );
  };
  
  export const canAccess = (state: RootState, permissionName: string): boolean => {
    const rolePermissions = state.permission?.permission || [];
 
    return rolePermissions.some(
      (permission) =>
        
        permission.permissionSystemName === permissionName && permission.scope === 'ALLOWED'
    );
  };